import { Injectable }    from '@angular/core';
import { BrowserXhr } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import { ProgressService } from '../customBrowserXhr/progress.service';

@Injectable()
export class CustomBrowserXhr extends BrowserXhr {

  constructor(private service:ProgressService) {
  	super();
  }

  build(): any {
    let xhr = super.build();
    xhr.onprogress = (event) => {
      this.service.progressEventObservable.next(event);
    };
    return <any>(xhr);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/customBrowserXhr/CustomBrowserXhr.ts